// AUTO-GENERATED by scripts/generate-posts.js. Do not edit by hand.
// Drop a new file in src/data/posts/ and run `bun dev` or `bun run build`.

import { parseMarkdown, readingTime } from '../lib/markdown.js';

const raw = [];

export const posts = raw
  .map((source) => {
    const parsed = parseMarkdown(source);
    return {
      ...parsed.frontmatter,
      tags: parsed.frontmatter.tags || [],
      readingTime: readingTime(source),
      blocks: parsed.blocks
    };
  })
  .sort((a, b) => (a.date < b.date ? 1 : -1));

export function getPost(slug) {
  return posts.find((p) => p.slug === slug);
}
